module.exports = __webpack_public_path__ + "img/fontColor.24c649e7.svg";